// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"co_a bhu_a bhu_w","Messages__hasSeen":"co_b bhu_p"};